import React from "react";
import { useParams } from "react-router-dom";

import ThreadList from "./thread-list";
import Thread from "./thread";

const Inbox = () => {
  const { threadId } = useParams();

  return (
    <div className="inboxLayout">
      <ThreadList />
      {threadId ? (
        <Thread key={threadId} />
      ) : (
        <div className="inboxThreadPane">
          <div className="inboxEmptyState">Select an email to read it</div>
        </div>
      )}
    </div>
  );
};

export default Inbox;
